import React, { useState } from "react";
import { Tabs, Tab } from '@appkit4/react-components/tabs';
import Box from '@mui/material/Box';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../Loader/Loader';
import { Tooltip } from '@appkit4/react-components/tooltip';
import InstructionDisplay from '../DraftGenerationInfo/DraftGenerationinfo';
import ExcelDraftGeneration from "../ExcelDraftGeneration/ExcelDraftGeneration";
import PptDraftGeneration from "../PptDraftGeneration/PptDraftGeneration";

const DraftGeneration: React.FC = () => {
    const [activeIndex, setactiveIndex] = React.useState(0);
    const [loading, setLoading] = useState<Boolean>(false);
    const onTabChange = (i: number, value: string) => {
        setactiveIndex(i);
    }

    return <>
        {loading && <Loader />}
        <div className="drafgenerationcontainer">
            <Tabs type='underline' activeIndex={activeIndex} onTabChange={onTabChange}>
                 <Tab label='Instructions' value="Instructions">
                    <Box sx={{ width: '100%' }}>
                        <InstructionDisplay></InstructionDisplay>
                    </Box>
                </Tab>
                <Tab label='1 - Excel' value="1 - Excel">
                    <Box sx={{ width: '100%' }}>
                        <ExcelDraftGeneration></ExcelDraftGeneration>
                    </Box>
                </Tab>
                {/* <Tab label='2 - Powerpoint' value="2 - Powerpoint">
                    <Box sx={{ width: '100%' }}>
                        <PptDraftGeneration></PptDraftGeneration>
                    </Box>
                </Tab> */}
            </Tabs>
        </div>
        <ToastContainer autoClose={5000} />
    </>
}

export default DraftGeneration


